<mojo-reports-job-item-common
  [jobItem]="jobItem"
  [aggregatedJobData]="aggregatedJobData"
>
  <mojo-pipeline-total-matches-numbers
    middle
    *ngIf="aggregatedJobData"
    [aggregatedJobData]="aggregatedJobData"
  >
  </mojo-pipeline-total-matches-numbers>
  <mojo-pipeline-total-direct-per-phases
    right
    [totalDirectPerPhasesData]="jobTotalDirectPerPhases$ | async"
  >
  </mojo-pipeline-total-direct-per-phases>
</mojo-reports-job-item-common>
